import { useTranslate } from '@prenuvo/halo-web';
import type { PulseError } from '@prenuvo/pulse';

import { isApiErrorData, isEmpty } from '../util';

export function useApiErrorMessage(error: unknown, fallback: string): string | undefined {
  const translate = useTranslate();
  const fallbackTranslation = translate(fallback);

  if (!(error instanceof Error)) {
    return fallbackTranslation;
  }

  const data = (error as PulseError).response?.data;

  if (!isApiErrorData(data) || data.length === 0) {
    return fallbackTranslation;
  }

  const messages = data.map((item) => {
    if (item.code) {
      const translated = translate(item.code);

      if (translated !== undefined && translated !== item.code) {
        return translated;
      }
    }

    return item.detail;
  });

  return isEmpty(messages) ? fallbackTranslation : messages.join('\n');
}
